export enum ShipmentDeliveryType {
    JOB = 'JOB',
    BIDDING = 'BIDDING',
    DELIVERY = 'DELIVERY'
}
